'use client';

import React from 'react';
import { CaseData, IImage } from '@sapientpro/sapientpro-data-models';
import Link from 'next/link';
import styles from './ServiceCase.module.scss';
import Img from '../../../../components/Img';

interface IProps {
  serviceCase: CaseData,
  image: IImage,
  caseTitle: string,
  caseDescription: string,
}

const ServiceCase = ({
  caseTitle,
  caseDescription,
  serviceCase,
  image,
}: IProps) => (
  <Link
    href={`/cases/${serviceCase?.slug}`}
    className={styles.serviceCase}
  >
    <div className={styles.caseLabel}>Case</div>
    <div className={styles.caseContainer}>
      <h6 className={styles.title}>{caseTitle}</h6>
      <div
        className={styles.description}
        dangerouslySetInnerHTML={{ __html: caseDescription }}
      />
      <div className={styles.technologies}>
        <p className={styles.technologies__title}>Technologies</p>
        <div className={styles.technologies__content}>
          {serviceCase?.technologies.map(technology => (
            <div
              className={styles.technology}
              title={technology.name}
              key={technology.id}
            >
              <img
                loading='lazy'
                src={technology.image?.light.url}
                alt={technology.image?.light.alternativeText || 'technology image'}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
    <div className={styles.images}>
      {image && (
        <div className={styles.imageWrapper}>
          <Img
            src={image.url}
            alt={image.alternativeText || 'service'}
            className={styles.image}
            priority
            withPreloader
          />
        </div>
      )}
    </div>
  </Link>
);

export default ServiceCase;
